var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-sidebar-login" }, [
    _c(
      "section",
      {
        staticClass: "login component",
        attrs: { "data-component": "login-component" },
      },
      [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c("div", { staticClass: "logo-wrapper" }, [
              _c("div", { staticClass: "logo-fomo icon-fan-logo-black" }, [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.tc("auth.fansMoTitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("login-form", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var serverErrorMsg = ref.serverErrorMsg
                    var isValid = ref.isValid
                    var isLoading = ref.isLoading
                    var grecaptchaReadyCallback = ref.grecaptchaReadyCallback
                    var grecaptchaReady = ref.grecaptchaReady
                    var grecaptchaCallback = ref.grecaptchaCallback
                    var grecaptchaExecute = ref.grecaptchaExecute
                    var grecaptchaToken = ref.grecaptchaToken
                    return _c(
                      "form",
                      {
                        staticClass: "form login-form",
                        attrs: { id: "login-form" },
                      },
                      [
                        _c("fieldset", [
                          _c("legend", [
                            _vm._v(_vm._s(_vm.loginComponentData.Title)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-grid-1-col gutter-lg" },
                            [
                              _c("div", { staticClass: "input" }, [
                                _c("input", {
                                  staticClass: " req",
                                  attrs: {
                                    id: "email",
                                    type: "text",
                                    name: "username",
                                    value: "",
                                    "data-val": "true",
                                    "data-val-required":
                                      _vm.getValidationForField(
                                        "required",
                                        "userIdentifier"
                                      ),
                                    "data-clear": "true",
                                    "data-field-type": "SingleLineText",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "req floating",
                                    attrs: { for: "username" },
                                  },
                                  [
                                    _vm._v(
                                      "\n\n                  " +
                                        _vm._s(
                                          _vm.tc("formFields.userIdentifier")
                                        ) +
                                        "\n\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "field-validation-valid",
                                  attrs: {
                                    "data-valmsg-for": "username",
                                    "data-valmsg-replace": "true",
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input" }, [
                                _c("input", {
                                  staticClass: " req",
                                  attrs: {
                                    id: "password",
                                    type: "password",
                                    name: "password",
                                    value: "",
                                    autocomplete: "current-password",
                                    "data-val": "true",
                                    "data-val-required":
                                      _vm.getValidationForField(
                                        "required",
                                        "password"
                                      ),
                                    "data-field-type": "PasswordField",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "req floating",
                                    attrs: { for: "password" },
                                  },
                                  [
                                    _vm._v(
                                      "\n\n                  " +
                                        _vm._s(_vm.tc("formFields.password")) +
                                        "\n\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("em", {
                                  staticClass: "fa fa-eye password-toggle",
                                  attrs: {
                                    "aria-label": _vm.tc(
                                      "formFields.passwordVisiblityToggle"
                                    ),
                                    tabindex: "0",
                                    type: "button",
                                    role: "switch",
                                    "aria-checked": "false",
                                    "data-for": "password",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "field-validation-valid",
                                  attrs: {
                                    "data-valmsg-for": "password",
                                    "data-valmsg-replace": "true",
                                  },
                                }),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-grid-2-col gutter-lg form-options ",
                            },
                            [
                              _c("ul", { staticClass: "remember-me" }, [
                                _c("li", [
                                  _c("label", [
                                    _c("input", {
                                      attrs: {
                                        id: "remember_me",
                                        name: "remember_me",
                                        type: "checkbox",
                                      },
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.tc("auth.rememberMe")) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "remember_me",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input no-label" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "forgot-password",
                                    attrs: {
                                      href: _vm.loginComponentData.ForgotLink,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.tc("auth.forgotPassword"))
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.loginComponentData.ReCaptchaEnabled
                          ? [
                              _c("grecaptcha", {
                                ref: "grecaptchaLogin",
                                attrs: {
                                  sitekey:
                                    _vm.loginComponentData.ReCaptchaSiteKey,
                                  "element-id": "g-recaptcha",
                                },
                                on: {
                                  "grecaptcha-callback": grecaptchaCallback,
                                  "grecaptcha-ready": grecaptchaReadyCallback,
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: grecaptchaToken,
                                    expression: "grecaptchaToken",
                                  },
                                ],
                                attrs: {
                                  type: "hidden",
                                  name: "grecaptchaToken",
                                },
                                domProps: { value: grecaptchaToken },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    grecaptchaToken = $event.target.value
                                  },
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-submit" }, [
                          _vm.loginComponentData.ReCaptchaEnabled
                            ? _c(
                                "button",
                                {
                                  staticClass: "button login-cta",
                                  class: [{ loading: isLoading }],
                                  attrs: {
                                    disabled: !isValid || !grecaptchaReady,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return grecaptchaExecute($event)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.tc("auth.signIn")) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _c(
                                "button",
                                {
                                  staticClass: "button login-cta",
                                  class: [{ loading: isLoading }],
                                  attrs: { disabled: !isValid },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.tc("auth.signIn")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "sr-only",
                              attrs: { role: "status" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    isLoading
                                      ? _vm.tc(
                                          "accessibility.loadingButtonStatus"
                                        )
                                      : ""
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "error-msg",
                          class: [{ show: !!serverErrorMsg }],
                          domProps: { innerHTML: _vm._s(serverErrorMsg) },
                        }),
                      ],
                      2
                    )
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "join-fans component",
        attrs: { "data-component": "join-fans-component" },
      },
      [
        _c("div", { staticClass: "join-fans-wrapper" }, [
          _c("div", { staticClass: "join-fans-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.fansJoinComponentData.Title) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "join-fans-description" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.fansJoinComponentData.SubTitle) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "benefits-list" },
            _vm._l(_vm.fansJoinComponentData.Benefits, function (benefit) {
              return _c("li", { staticClass: "benefits-list-item" }, [
                _c("span", {
                  staticClass: "icon",
                  style: "background-image: url('" + benefit.IconUrl + "')",
                }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(benefit.Description))]),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "cta-wrapper" }, [
              _c(
                "a",
                {
                  staticClass: "cta-join-now",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("change-component", "registration")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.fansJoinComponentData.JoinNowLabel) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "cta-learn-more",
                  attrs: {
                    href: _vm.fansJoinComponentData.LearnMoreLink,
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.fansJoinComponentData.LearnMoreLabel) +
                      "\n          "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }